/**
 * Created by smallking on 2019/1/28.
 */
export default {

  //sessionStorage
  setSession(name, content){
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.sessionStorage.setItem(name, content);
  },
  getSession(name){
    return window.sessionStorage.getItem(name);
  },
  removeSession(name){
    window.sessionStorage.removeItem(name);
  },


  //localStorage
  setStore(name, content){
    if (typeof content !== 'string') {
      content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
  },
  getStore(name){
    return window.localStorage.getItem(name);
  },
  removeStore(name){
    window.localStorage.removeItem(name);
  }
}



// WEBPACK FOOTER //
// ./src/config/mySession.js